import { createConsumer } from '@rails/actioncable';
import { create } from 'zustand';

type Consumer = ReturnType<typeof createConsumer>;

type UseChannelStore = {
	consumer: Consumer;
	initialize: (url: string) => void;
};

export const useChannelStore = create<UseChannelStore>((set) => ({
	consumer: null as any,
	initialize: (url: string) => set({ consumer: createConsumer(url) }),
}));
